import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LookupData } from '../models/lookup';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntidadFinancieraService {

  myAppUrl: string = "";

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getEntidades() {
    return this._http.get(this.myAppUrl + 'api/EntidadFinanciera');
  }

  getEntidadesById(id: number) {
    return this._http.get(this.myAppUrl + 'api/EntidadFinanciera/' + id );
  }

  createEntidad(entidad: any) {
    return this._http.put(this.myAppUrl + 'api/EntidadFinanciera/', entidad);
  }

  updateEntidad(id: number,entidad:any) {
    return this._http.post(this.myAppUrl + 'api/EntidadFinanciera/' + id, entidad);
  }

  deleteEntidad(id:number) {
    return this._http.delete(this.myAppUrl + 'api/EntidadFinanciera/' + id);
  }
}
